import { PkDivider } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { Suspense, lazy, memo, useMemo } from 'react';

import { useMenuOptions } from '../../store';
import { sendHeaderTracking } from '../../utils';
import HomeLink from '../MenuItems/HomeLink';
import More from '../More';

import { useWindowSize } from '@hooks/useWindowSize';
import { LoginButton } from '@shared/LoginButton';
import { useTranslateFn } from '@shared/Translate';
import { AUTH_FLOW_TYPE } from '@shared-types/idp.types';

import * as styles from './styles.module.scss';

const MenuItems = lazy(() => import(/* webpackPrefetch: true */ '../MenuItems'));
const ClubSelector = lazy(() => import(/* webpackPrefetch: true */ '../../../club-selector/app'));

export const Menu = () => {
  const {
    options: { activateFavouriteClub, activateLoginButton, isCorporateContext, customUserPage },
  } = useMenuOptions();
  const { isMobile, isHoverDevice, isTablet, isLandscape } = useWindowSize();
  const isMobileOrTouch = isMobile || !isHoverDevice;
  const t = useTranslateFn();

  const isNotMobileOrLandscape = !(isMobile || (isLandscape && isTablet));

  const handleLoginClick = () => {
    sendHeaderTracking('Login', 'Level 1', '');
  };

  const corporateLoginButton = useMemo(
    () => (
      <LoginButton
        appearance={isMobileOrTouch ? 'text' : 'outlined'}
        rounded
        type={AUTH_FLOW_TYPE.LOGIN}
        showLabel={!isMobile}
        showUsername
        hideIfLogged={false}
        onClick={handleLoginClick}
        customUserPage={customUserPage}
      />
    ),
    [customUserPage, isMobileOrTouch, isMobile],
  );

  const loginButton = useMemo(() => {
    if (!activateLoginButton) return null;

    if (isCorporateContext) {
      return corporateLoginButton;
    }

    if (isMobile) return null;

    return <LoginButton customUserPage={customUserPage} />;
  }, [activateLoginButton, isCorporateContext, isMobile, customUserPage, corporateLoginButton]);

  return (
    <nav aria-label={t('main_navigation')} className={styles.navMenu}>
      <HomeLink />
      {(!isCorporateContext || !isMobileOrTouch) && <MenuItems />}
      {activateFavouriteClub && isNotMobileOrLandscape && (
        <div className='club-selector club-selector-menu-lev2'>
          <Suspense>
            <ClubSelector />
          </Suspense>
        </div>
      )}
      {activateLoginButton && (
        <div
          className={clsx('pk-d--flex pk-align-items--center', isCorporateContext && !isMobileOrTouch && 'pk-ml--s')}
        >
          {loginButton}
          {isCorporateContext && isMobileOrTouch && (
            <>
              <PkDivider className='pk-d--flex pk-m--0 pk-ml--m pk-py--m pk-py-sm--l' direction='vertical' />
              <More />
            </>
          )}
        </div>
      )}
    </nav>
  );
};

export default memo(Menu);
